export default __webpack_public_path__ + "static/media/Group714.bddfcd2b.png";